function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
//Limitless imports
import Typography from "@limitless/modern/data-display/typography/Typography";
import { withi18n } from "../../../../../customer/components";
import { INITIAL_MESSAGE_FLAG_STATE } from "../../../../../expert";
import ExpertDialogueWrapper from "../expert-dialogue-wrapper/ExpertDialogueWrapper";
import ExpertDialogueBody from "../expert-dialogue-body/ExpertDialogueBody";
import ExpertTimePosted from "../expert-time-posted/ExpertTimePosted";
const ExpertFlagDialogue = ({
  t,
  classes,
  dialogue,
  ...rest
}) => {
  const {
    created
  } = dialogue;
  let flagTypeData = INITIAL_MESSAGE_FLAG_STATE["report"];
  if (rest.message.escalateNote) {
    flagTypeData = INITIAL_MESSAGE_FLAG_STATE["escalation"];
  }
  return /*#__PURE__*/React.createElement(ExpertDialogueWrapper, _extends({
    shouldAnimate: false,
    dialogue: dialogue
  }, rest), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ExpertDialogueBody, {
    classes: {
      backgroundColor: classes.backgroundColor
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.expertText
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    className: classes.expertText
  }, t(flagTypeData.dialogueTitle)), /*#__PURE__*/React.createElement("div", {
    className: classes.lineWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    className: `${classes.noWrap} ${classes.expertText}`
  }, t("Reason:")), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    className: classes.expertText
  }, rest.message[flagTypeData.reasonDescKey])), /*#__PURE__*/React.createElement("div", {
    className: classes.lineWrapper,
    style: {
      marginBottom: 0
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    className: `${classes.noWrap} ${classes.expertText}`
  }, t("Description:")), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    className: classes.expertText
  }, rest.message[flagTypeData.noteKey])))), /*#__PURE__*/React.createElement(ExpertTimePosted, {
    dialogue: dialogue,
    time: created
  })));
};
const styles = ({
  palette
}) => ({
  backgroundColor: {
    backgroundColor: palette.warning.light
  },
  expertText: {
    color: palette.secondary.contrastText
  },
  lineWrapper: {
    display: "flex",
    marginTop: 8,
    whiteSpace: "pre-wrap",
    wordWrap: "break-word",
    wordBreak: "break-word",
    overflow: "hidden",
    alignItems: "baseline"
  },
  noWrap: {
    whiteSpace: "nowrap",
    marginRight: 4
  }
});
export default withStyles(styles)(withi18n(ExpertFlagDialogue));
ExpertFlagDialogue.propTypes = {
  dialogue: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired
};